import { Deal } from './Deal'

export default Deal
